export const Transaction = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.2882 4.67834L26.5903 10.0157L21.3073 15.3017" stroke="currentColor" stroke-width="2"/>
<path d="M4 10H26" stroke="currentColor" stroke-width="2"/>
<path d="M10.7118 27.3295L5.40967 21.9921L10.6927 16.7061" stroke="currentColor" stroke-width="2"/>
<path d="M28 22.0078L6 22.0078" stroke="currentColor" stroke-width="2"/>
</svg>`;
